<template>
  <div class="examination-list-table-row-group">
    <div class="row-upper">
      <div class="toggle-mark" @click="toggleShow">
        <img
          v-show="showResultTable"
          class="bottom-allow"
          src="@/assets/images/allow3.png"
        />
        <img
          v-show="!showResultTable"
          class="right-allow"
          src="@/assets/images/allow4.png"
        />
      </div>
      <div class="cell date">
        <span>{{ toJpDateFormat(resultGroup.date) }}</span>
      </div>
      <div class="cell examination-name">
        <span>{{ resultGroup.treatmentName }}</span>
      </div>
      <div class="cell blood-flg">
        <span>{{ toCircleOrCross(resultGroup.bloodFlg) }}</span>
      </div>
      <div class="cell file-name" />
      <div class="cell button">
        <base-button-border-orange
          :disabled="!canPrint"
          :styles="{ width: '120px' }"
          @click="emitClick"
          >検査結果印刷</base-button-border-orange
        >
      </div>
    </div>
    <div v-show="showResultTable" class="row-lower">
      <div class="table">
        <div class="table-header">
          <div class="table-cell">項目区分名</div>
          <div class="table-cell">項目名</div>
          <div class="table-cell">結果</div>
          <div class="table-cell">単位</div>
          <div class="table-cell">基準値</div>
          <div class="table-cell">コメント</div>
        </div>
        <div class="table-body">
          <div
            v-for="(resultTopicClass, index) in resultGroup.resultTopicClasses"
            class="topic-class"
            :key="`topic-class-${index}`"
          >
            <div class="topic-class-name">
              <span>{{ resultTopicClass.topicClassName }}</span>
            </div>
            <div class="topics">
              <div
                v-for="(resultTopic, index) in resultTopicClass.resultTopics"
                class="topic"
                :key="`topic-${index}`"
              >
                <div class="table-cell topic-name">
                  <span>{{ resultTopic.topicName }}</span>
                </div>
                <div class="table-cell result">
                  <span>{{ resultTopic.result }}</span>
                </div>
                <div class="table-cell unit">
                  <span>{{ resultTopic.unit }}</span>
                </div>
                <div class="table-cell reference">
                  <span>{{ resultTopic.reference }}</span>
                </div>
                <div class="table-cell comment">
                  <span>{{ resultTopic.comment }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButtonBorderOrange from '@/components/parts/atoms/BaseButtonBorderOrange'
import moment from 'moment'
import { toCircleOrCross } from '@/utils/convert_string'

export default {
  name: 'ExaminationListTableRowGroup',

  components: {
    BaseButtonBorderOrange
  },

  props: {
    resultGroup: { type: Object, default: () => ({}) }
  },

  data() {
    return {
      showResultTable: true
    }
  },

  computed: {
    canPrint() {
      return this.resultGroup.resultTopicClasses.length > 0
    }
  },

  methods: {
    emitClick() {
      this.$emit('click-print')
    },
    toCircleOrCross(numericBoolean) {
      return toCircleOrCross(numericBoolean)
    },
    toJpDateFormat(date) {
      return moment(date, 'YYYYMMDD').format('Y年M月D日（dd）')
    },
    toggleShow() {
      this.showResultTable = !this.showResultTable
    }
  }
}
</script>

<style lang="scss" scoped>
$border-color: #{$light-grey};

@mixin subgrid($gridSpan) {
  grid-column: span $gridSpan;
  display: grid;
  grid-template-columns: subgrid;
}

@mixin table-cell {
  box-sizing: border-box;
  padding: 5px 8px;
  border-right: 1px solid #{$light-grey};
  border-bottom: 1px solid #{$light-grey};
  display: grid;
  place-items: center;
  min-height: 30px;
  font-size: 13px;
  overflow-wrap: anywhere;
  line-break: strict;
}

.examination-list-table-row-group {
  > .row-upper {
    width: 100%;
    min-height: 55px;
    display: flex;
    align-items: center;
    position: relative;
    > .toggle-mark {
      position: absolute;
      margin-left: 21px;
      width: 16px;
      cursor: pointer;
      > .bottom-allow {
        margin-top: 5px;
        width: 15px;
        height: 9px;
      }
      > .right-allow {
        margin-top: 5px;
        width: 9px;
        height: 15px;
      }
    }
    > .cell {
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      height: 100%;
      padding: 5px 8px;
      word-break: break-all;
      font-feature-settings: 'palt';
      & ~ .cell {
        border-left: 1px solid transparent;
      }
      &.date {
        max-width: 220px;
        min-width: 220px;
      }
      &.examination-name {
        flex: 2;
      }
      &.blood-flg {
        max-width: 120px;
        min-width: 120px;
      }
      &.file-name {
        flex: 3;
      }
      &.button {
        max-width: 250px;
        min-width: 250px;
        justify-content: flex-end;
        padding-right: 20px;
      }
    }
  }
  > .row-lower {
    box-sizing: border-box;
    display: flex;
    width: 100%;
    padding: 0 20px 20px 20px;
    > .table {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      width: 100%;
      border-top: 1px solid #{$light-grey};
      border-left: 1px solid #{$light-grey};
      > .table-header {
        @include subgrid(6);
        background-color: #{$gray_f0};
        > .table-cell {
          @include table-cell;
          padding: 0;
          font-weight: bold;
        }
      }
      > .table-body {
        @include subgrid(6);
        background-color: #{$white};
        > .topic-class {
          @include subgrid(6);
          > .topic-class-name {
            @include subgrid(1);
            @include table-cell;
          }
          > .topics {
            @include subgrid(5);
            > .topic {
              @include subgrid(5);
              > .table-cell {
                @include table-cell;
              }
            }
          }
        }
      }
    }
  }
}
</style>
